'use strict'
module.exports = new LiteralSearchStrategy()

function LiteralSearchStrategy(){
  this.matches = function(string,crit){
    if( typeof string !== 'string' ){
      return false
    }
    string = string.trim()
    return string.toLowerCase().indexOf(crit.toLowerCase()) >= 0
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/simple-jekyll-search/src/SearchStrategies/LiteralSearchStrategy.js
// module id = 8
// module chunks = 0